import { Grid, Typography } from '@mui/material';
import { useEffect } from 'react';
import { getProfile } from '../../redux_store/slices/GetUserProfileSlice';
import { useAppDispatch } from '../../redux_store/reduxStore';

export const Home = () => {
  const dispatch = useAppDispatch();

  async function getUserProfile() {
    await dispatch(getProfile(''));
  }

  useEffect(() => {
    getUserProfile();
  }, []);

  return (
    <Grid>
      <Typography>HOME</Typography>
    </Grid>
  );
};
